var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4995 24.5385L11.4996 24.5385C12.1825 25.2013 13.2651 25.1414 13.874 24.4157L28.6065 6.8607C28.6065 6.86065 28.6066 6.86061 28.6066 6.86056C29.1907 6.16472 29.1176 5.11574 28.4324 4.51116L24.9234 1.41399C24.9233 1.41391 24.9232 1.41382 24.9231 1.41373C24.2232 0.795696 23.1586 0.881939 22.5625 1.59233L12.1608 13.9864L6.99468 8.97243L6.99444 8.97221C6.32605 8.32392 5.25873 8.35502 4.62816 9.03832L1.44528 12.4874L1.44508 12.4876C0.828525 13.1561 0.854899 14.2068 1.50955 14.8422L11.4995 24.5385ZM11.9012 14.2958C11.9013 14.2956 11.9014 14.2955 11.9015 14.2954L11.9013 14.2957L11.9012 14.2958Z",
    stroke: "#52CC74",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.73c1aad6.svg";
export { ForwardRef as ReactComponent };